import { render, staticRenderFns } from "./EventServiceParticipants.vue?vue&type=template&id=74be4395&"
import script from "./EventServiceParticipants.vue?vue&type=script&lang=js&"
export * from "./EventServiceParticipants.vue?vue&type=script&lang=js&"
import style0 from "./EventServiceParticipants.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports